import catalog from '@/i18n/generated/posthog-support-locales.json';
import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

export type PostHogSupportCopy = (typeof catalog)['en'];

const copyByLocale: Record<SupportedLocale, PostHogSupportCopy> = catalog;

export function getPostHogSupportCopy(
  locale: string | null | undefined
): PostHogSupportCopy {
  return copyByLocale[normalizeLocale(locale)];
}
